export const year: number[] = [...new Array(20)].map((item, index) => (item = 2012 + index));
export const month: number[] = [...new Array(12)].map((item: number, index) => (item = 1 + index));
